import React, { Component, lazy, Suspense } from "react";
import { IonApp, IonSpinner, setupIonicReact, isPlatform } from "@ionic/react";
import { Device } from "@capacitor/device";

import "./SharedCode/theme/variables.css";
import "./App.css";
import ErrorBoundary from "./SharedCode/components/ErrorBoundary";
import { Subscriptions } from "capacitor-subscriptions";
import { IScreenProps } from "./SharedCode/Interfaces";

if (
  (isPlatform("ios") || isPlatform("android")) &&
  isPlatform("mobileweb") === false &&
  isPlatform("tablet") === false
) {
  setupIonicReact({
    swipeBackEnabled: true,
  });
} else {
  setupIonicReact({
    swipeBackEnabled: false,
  });
}

const SharedApp = lazy(() => import("./SharedCode/SharedApp"));

type Props = {};
type State = {
  app: IScreenProps["app"];
  showLoadingScreen: boolean;
  isAndroid15OrHigher: boolean;
};

class App extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      app: "CFR",
      showLoadingScreen: true,
      isAndroid15OrHigher: false,
    };
  }

  async componentDidMount() {
    let isAndroid15OrHigher = await this.isAndroid15OrHigher();
    this.setState({ isAndroid15OrHigher });
    if (isPlatform("android")) {
      Subscriptions.setGoogleVerificationDetails({
        // googleVerifyEndpoint: 'https://class.aimernginx.co.uk/aimerapi/verifyWithGoogleAimer',
        googleVerifyEndpoint: "https://class.aimernginx.co.uk/eos/verifyWithGoogleAimer",
        bid: "uk.co.classprofessional.cfr",
      });
    }
  }

  showLoadingScreen(shouldShow: boolean) {
    this.setState({ showLoadingScreen: shouldShow });
  }

  changeApp(app: IScreenProps["app"]) {
    this.setState({ app: app });
  }

  async isAndroid15OrHigher(): Promise<boolean> {
    try {
      const info = await Device.getInfo();

      if (info.platform === "android") {
        const version = parseInt(info.osVersion.split(".")[0], 10);
        return version >= 15;
      }
    } catch (error) {}
    return false;
  }

  render() {
    return (
      <IonApp className={`${this.state.isAndroid15OrHigher ? "androidEdgeToEdge" : ""}`}>
        <Suspense
          fallback={
            <div className="loadingScreen">
              <div className="loadingScreenText">Loading</div>
              <IonSpinner className="loadingScreenSpinner" />
            </div>
          }
        >
          <>
            <ErrorBoundary>
              <SharedApp
                app={this.state.app}
                hostApp="CFR"
                changeApp={this.changeApp.bind(this)}
                showLoadingScreen={this.showLoadingScreen.bind(this)}
              />
            </ErrorBoundary>
            {this.state.showLoadingScreen ? (
              <div className="loadingScreen">
                <div className="loadingScreenText">Loading</div>
                <IonSpinner className="loadingScreenSpinner" />
              </div>
            ) : null}
          </>
        </Suspense>
      </IonApp>
    );
  }
}

export default App;
